<script lang="ts" setup>
import { useStoreConfig } from '~/store/storeConfig'
import LayoutEnum from '~/enums/LayoutEnum'

const { type, disableQuoteBar } = defineProps<{
  type?: LayoutEnum.Market | LayoutEnum.Quote
  disableQuoteBar?: boolean
}>()

const { isAlt, isWhitelabel, isAmeerikaEestis } = useTheme()
const { isMobile } = useStoreConfig()
const { isEnabled } = useQuoteCategory()
</script>

<template>
  <div>
    <template v-if="isAlt">
      <template v-if="isWhitelabel">
        <LazyMobileHeaderWl v-if="isMobile" />
        <div v-else>
          <HeaderWl :type="type" />
        </div>
      </template>
      <template v-else-if="isAmeerikaEestis">
        <LazyMobileHeaderAe v-if="isMobile" />
        <div v-else>
          <HeaderAe :type="type" />
        </div>
      </template>
      <template v-else>
        <LazyMobileHeaderJav v-if="isMobile" />
        <div v-else>
          <HeaderJav :type="type" />
        </div>
      </template>
    </template>
    <template v-else>
      <LazyMobileHeader v-if="isMobile" />
      <div v-else>
        <Header :type="type" />
        <LazyQuoteBar v-if="type === LayoutEnum.Quote && isEnabled() && !disableQuoteBar" />
        <CategoryBar v-if="type === LayoutEnum.Market" />
      </div>
    </template>
  </div>
</template>
